<template>
  

<div class="container">
      <h3 class="heading">الاسئلة</h3>

      <form @submit.prevent="postinfo">
        




<div v-for="(keey,index) in listt" :key="keey.inc" >

      <h3 class="heading">  {{index+1 }} سؤال </h3>

<div class="mb-3 input-in-con">
         <div v-if="errList">
  <div v-if="errList[index].questinon"  class="alert alert-danger" role="alert"> {{ errList[index].questinon[0]}}</div>
</div>
  <label for="exampleFormControlInput1" class="form-label">سؤال</label>
  <textarea type="text" class="form-control rtl" rows="5" id="exampleFormControlInput1" placeholder="اكتب السؤال" v-model="keey.questinon">

  </textarea>
</div>


<div class="mb-3 input-in-con">
        <div v-if="errList">
  <div v-if="errList[index].answer"  class="alert alert-danger" role="alert"> {{ errList[index].answer[0]}}</div>
</div>
  <label for="exampleFormControlInput1" class="form-label">جواب</label>
  <textarea  type="text" class="form-control rtl" rows="5" id="exampleFormControlInput1" placeholder="اكتب الجواب" v-model="keey.answer">

  </textarea>
</div>
 
<!--<Recorder @send-audio="TakeBlob" /> -->

<div class="mb-3 input-in-con">
      <div v-if="errList">
  <div v-if="errList[index].note"  class="alert alert-danger" role="alert"> {{ errList[index].note[0]}}</div>
</div>
  <label for="exampleFormControlInput1" class="form-label">ملاحظة</label>
  <textarea  type="text" class="form-control rtl" rows="5" id="exampleFormControlInput1" placeholder="اكتب ملاحظة" v-model="keey.note">

  </textarea>
</div>
<!--<div class="mb-3 input-in-con  ">
           <div v-if="this.err">
  <div v-if="this.err.record"  class="alert alert-danger" role="alert"> {{ this.err.record[0]}}</div>
</div>
  <label for="exampleFormControlInput1" class="form-label">المحقق</label>
 <select class="form-select " aria-label="Default select example" v-model="formdata.record" >
  <option disabled selected>اختر المحقق</option>
  <option  v-for="key in formdata2" :value="key.id">{{key.id}}</option>
</select>
</div> -->
</div>


<div class="flex last">
  <p @click="shoecom" class="btn btn-primary">اضافة سؤال جديد</p>
</div>

<!--<div class="flex last">
  <button  class="btn btn-primary" >اضافة</button>
</div> -->

      </form>

  </div>


</template>

<script setup>
import { ref, onMounted,reactive } from 'vue'
import { useRoute } from 'vue-router'
import  geturl  from "@/comp/geturl";
//import Recorder from '@/components/Recorder.vue'

const route = useRoute()

 /*const formdata = ref({
  questinon: "",
  answer: "",
  note: "",
  record: route.params.id
 })*/
 const formdata2 = ref(null)
 //const err = ref(null)

 /*const immg = (e)=>{
  
  var reader = new window.FileReader();
  reader.readAsDataURL(e.target.files[0]);
  reader.onload = function(){
    var dataUrl = reader.result;
            formdata.value.voice = dataUrl

  }
 }*/

 /*const TakeBlob = (n)=>{
console.log('blooo',n)
formdata.voice = n

var reader = new window.FileReader();
  reader.readAsDataURL(n);
  reader.onload = function(){
    var dataUrl = reader.result;

   //formdata.value.voice = dataUrl
    console.log(formdata.value.voice)
  }


 }*/

 const listt = reactive( [] )
 const errList = reactive( [] )
 const inc = ref( 0 )


onMounted(()=>{

  fetch(geturl()+"records/record/", {
        
        headers: {"Content-Type": "application/json"},
        })
        .then(res => res.json())
        .then(data => {formdata2.value = data
        })

})


const shoecom = () =>{
if(inc.value>0){

  fetch(geturl()+"records/question/", {
         method: "POST",
      headers: {"Content-Type": "application/json"},
      body: JSON.stringify(listt[inc.value-1])
      })
      .then(res => res.json())
      .then(data => { 
        if(data.error){
          errList[inc.value-1] = data.error.details
                  }
      else{
        errList[inc.value-1] ={name:''}
        listt.push({
      
      inc:inc.value,
      questinon: "",
answer: "",
note: "",
record: route.params.id
}),
errList.push({
inc: inc.value,
questinon: "",
answer: "",
note: "",
})
inc.value = ++inc.value
       // router.push({name:'DetictiveView' })
      }
      })

}
else{
  
    listt.push({
      
             inc:inc.value,
             questinon: "",
  answer: "",
  note: "",
  record: route.params.id
    }),
    errList.push({
       inc: inc.value,
       questinon: "",
  answer: "",
  note: "",
    })
inc.value = ++inc.value
  }

}




</script>

<style>
.v-enter-active,
.v-leave-active {
transition: opacity 0.5s ease;
}
.v-enter-form,
.v-leave-to{
  opacity: 0;
}
</style>